import { ConfigProvider } from 'antd';
import './assets/styles/index.scss';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import routes from 'routes';
import AuthMiddleware from 'middlewares/authMiddleware';
import PageNotFound from 'components/shared/Error';
import { IRoute } from 'interfaces/routesInt';
import { usePlatformConfig } from 'hooks/PlatformContext';
import connect from 'services/socket';
import wallet from 'services/wallet';
import failedOperation from 'services/failedOperation';
import { useState, useEffect } from 'react';
import urls from 'routes/urls';
import BulkPaymentSocket from 'services/bulkPayment';
import CalculatedOpResultsModal from 'components/shared/CalculatedOp';
import { useUpdateConfirmModal } from 'hooks/useConfirmModal';
import RequestConfirmModal from 'components/shared/RequestConfirm';
import PendingRequestConfirm from 'components/shared/RequestConfirm/Pending';
import ErrorRequestConfirmModal from 'components/shared/RequestConfirm/ErrorRequestConfirm';
import { useLanguage } from 'hooks/Language/useLanguage';
import ErrorRequestConfirm from 'components/shared/RequestConfirm/Error';
import SuccessRequestConfirmModal from 'components/shared/RequestConfirm/SuccessRequestConfirm';
import SuccessRequestConfirm from 'components/shared/RequestConfirm/Success';
import ExecutedOpResultsModal from 'components/shared/ExecutedOp';
import ExecBulkPaymentSocket from 'services/execBulkPayment';
import SessionManager from 'components/bank/AGBBank/SessionManager/SessionManager';
import LocationModal from 'components/shared/LocationModal';
import LocationGuard from 'components/shared/LocationGuard';
import { LocationProvider } from 'Contexts/LocationContext';

function App() {
  const platformConfig = usePlatformConfig();
  const { props } = useUpdateConfirmModal();
  const backgroundColor = platformConfig.primaryColor;

  connect();
  wallet();
  failedOperation();

  const [count, setCount] = useState(0);
  const { translate } = useLanguage();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [calculationResponse, setCalculationResponse] =
    useState<any>(null);
  const [executionResponse, setExecutionResponse] =
    useState<any>(null);
  const [isExModalOpen, setIsExModalOpen] = useState<boolean>(false);

  const handleCalculationDone = (response: any) => {
    setCalculationResponse(response);
    setIsModalOpen(true);
  };

  const handleExecutionDone = (response: any) => {
    setExecutionResponse(response);
    setIsExModalOpen(true);
    localStorage.removeItem('opExInProgress');
  };

  // Handle browser back button
  useEffect(() => {
    const onBackButtonEvent = (e: any) => {
      e.preventDefault();
      if (window.location.pathname === urls.dashboard) {
        setCount((prev) => prev + 1);
      }
    };

    window.history.pushState(null, '', window.location.pathname);
    window.addEventListener('popstate', onBackButtonEvent);

    return () => {
      window.removeEventListener('popstate', onBackButtonEvent);
    };
  }, []);

  useEffect(() => {
    if (count > 0) {
      window.location.href = window.location.pathname;
    }
  }, [count]);

  // Redirect logged-in users from login/home to dashboard
  useEffect(() => {
    const userToken = localStorage.getItem('userToken');
    if (window.location.pathname === '/login' && userToken) {
      window.location.href = urls.dashboard;
    }
    if (window.location.pathname === '/' && userToken) {
      window.location.href = urls.dashboard;
    }
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: backgroundColor,
        },
      }}
    >
      <LocationProvider>
        <div className="App hide-horizontal-scroll">
          {/* Location Modal - Shows when location is not enabled */}
          <LocationModal allowDismiss={true} />

          <BulkPaymentSocket
            onCalculationDone={handleCalculationDone}
          />

          <ExecBulkPaymentSocket
            onExecutionDone={handleExecutionDone}
          />

          {calculationResponse && (
            <CalculatedOpResultsModal
              visible={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              calculatedOp={calculationResponse}
            />
          )}

          {executionResponse && (
            <ExecutedOpResultsModal
              visible={isExModalOpen}
              onClose={() => setIsExModalOpen(false)}
              calculatedOp={executionResponse}
            />
          )}

          <RequestConfirmModal
            icon={<PendingRequestConfirm />}
            translate={translate}
            title={props?.title}
            subtitle={translate(props?.subtitle)}
            status={{ isPending: props?.status?.isPending }}
            onClick={props?.onClick}
            transactionDetails={{
              TransactionID:
                props?.sendFundsToGatewayData?.TransactionID ||
                props?.moneyFromGatewayData?.TransactionID ||
                '',
              Amount:
                props?.transactionDetails?.Amount ||
                props?.moneyFromGatewayData?.Amount ||
                '',
              Fees: props?.transactionDetails?.Fees || '',
              ExchangeFees:
                props?.transactionDetails?.ExchangeFees || '',
              Taxes: props?.transactionDetails?.Taxes || '',
              TotalAmount:
                props?.transactionDetails?.TotalAmount || '',
              ExchangeRate: props?.transactionDetails?.ExchangeRate,
            }}
          />

          <ErrorRequestConfirmModal
            translate={translate}
            icon={<ErrorRequestConfirm />}
            title={'Failed'}
            subtitle={props?.message}
          />

          <SuccessRequestConfirmModal
            translate={translate}
            icon={<SuccessRequestConfirm />}
            title={'Success'}
            subtitle={props?.message}
          />

          <BrowserRouter basename="/">
            <SessionManager>
              <Routes>
                {routes.map((route: IRoute, index: number) => {
                  // const RouteElement = route.requireLocation ? (
                  //   <LocationGuard requireLocation={true}>
                  //     {route.element}
                  //   </LocationGuard>
                  // ) : (
                  //   route.element
                  // );
                  //
                  const RouteElement = route.element;
                  return route.isProtected ? (
                    <Route
                      key={index}
                      element={
                        <AuthMiddleware
                          isAuthProtected={route.isProtected}
                        />
                      }
                    >
                      <Route
                        path={route.path}
                        key={route.key}
                        index={route.index}
                        element={RouteElement}
                      />
                    </Route>
                  ) : (
                    <Route
                      path={route.path}
                      key={route.key}
                      index={route.index || true}
                      element={RouteElement}
                    />
                  );
                })}
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </SessionManager>
          </BrowserRouter>
        </div>
      </LocationProvider>
    </ConfigProvider>
  );
}

export default App;
